import { useState } from 'react';
import { useGetAccountQuery } from 'lib/services';

const useAccountDormantModal = () => {
    const { data: account } = useGetAccountQuery(undefined, {
        skip: !localStorage.getItem('cognitoToken'),
    });
    const isDormant = account?.isDormant ?? false;
    const [showDormantModal, setShowDormantModal] = useState(isDormant);

    function handleClose() {
        setShowDormantModal(false);
    }

    return [showDormantModal, handleClose] as const;
};

export default useAccountDormantModal;
